import { BaseContainerModel } from '../base-container.model';
export class CpCommercePgwGenerateRefNoRequestModel extends BaseContainerModel {
  constructor(
    public amount: number, //mandatory
    public currency: string, //mandatory
    public genDocHdrGuid: string, //mandatory
    public successPageUrl: string,
    public failPageUrl: string,
    public merchantCode: string, //mandatory
    public fiItemGuid: string, //settlementMethodFiItemGuid
    public paymentChannelCode: string
  ) {
    super();
  }
}
